import { ref, getDownloadURL } from "firebase/storage";
import { storage } from "../../firebase/config";
import { Blockquote, Inset, Text } from "@radix-ui/themes";


export default function Y2024M01() {


  return (
    <>
      <div className="container py-5">
        <div className='row'>

          <div className='col-lg-4'>
            <Inset clip="padding-box" side="top" pb="current">
              <img
                src="https://www.shadvala.org/img/interstices-2024-01-01.jpg"
                alt="Events"
                style={{
                  display: 'block',
                  objectFit: 'cover',
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'var(--gray-5)',
                }}
              />
              <Text as="p" mb="5" size="2">
                Photo by Amanda Viana
              </Text>
            </Inset>
          </div>

          <div className='col-lg-8'>
            <div className="container">
              <div className='row py-3 border-top'>
                <div className='col'>
                  <Text as="p" mb="5" size="2" weight="bold">
                    January 2024, Amazonia (Brazil)
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="4" color>
                    Research Work in Amazonia: <i>The Yawanawa Tradition</i>
                  </Blockquote>
                  <Blockquote size="2" color>
                    Center Interstices in collaboration with FAD
                  </Blockquote>
                </div>
              </div> 
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="3">
                    In the month of January, Amanda Viana de Sousa carried out research work in Amazon Rainforest at the <i>Yawarani</i> village, among the Yawanawa indigenous group, focusing on their socialization with non-humans (especially plants), their healing methods, and the oral transmission of knowledge by the old shamans.
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}
